import { Channel, ChannelSubscription, ChannelSubscriptionType, ChannelTypes } from '../shared/types';
import { AdminUser } from '../gql/users';
import { getPublisherUrl } from './utils';

export const getChannelPublisherUrl = (props: Channel) => {
	return getPublisherUrl({
		_id: props.ownerId,
		type: props.ownerType
	})
};

export const formatChannelSubscriptionType = (subscription: ChannelSubscription): string => {
	switch (subscription.subscriptionType) {
	case ChannelSubscriptionType.Account:
		return `${subscription.rebate ? 'Rebated' : 'Paid'} - Clearing`;
	case ChannelSubscriptionType.Stripe:
		return 'Paid - Non-clearing';
	case ChannelSubscriptionType.NonCharge:
		return 'Non-charge';
	case ChannelSubscriptionType.Trial:
		return 'Trial';
	case ChannelSubscriptionType.External:
		return 'Billed externally';
	default:
		return '';
	}
}

export const isChannelAdmin = (adminUsers: AdminUser[], neonUserId: string): boolean =>
	adminUsers.some(u => u._id === neonUserId);

export const isUserNotChannelAdmin = (adminUsers: AdminUser[], neonUserId: string): boolean  =>
	!adminUsers.some(u => u._id === neonUserId);

export const isPremiumChannelSubscription = (channelSubscriptionType: ChannelTypes) => channelSubscriptionType === ChannelTypes.premium ?
	'Premium Channel' : 'Channel';
